import { useMemo } from "react";

import { ListTile } from "@repo/core/components/layout/ListTile";
import { TileLabel } from "@repo/core/components/layout/ListTile/types";

import { PersonListTileProps } from "./types";

export const PersonListTile = ({
  id,
  name,
  isActive,
  onPress
}: PersonListTileProps) => {
  const labels = useMemo(() => {
    return [
      new TileLabel({
        text: "Nome",
        fontColor: "$textLight700",
        fontWeight: 500
      }),
      new TileLabel({
        text: name || "",
        fontColor: "$textLight900",
        fontWeight: 600,
        fontSize: "md"
      })
    ];
  }, [name]);

  return (
    <ListTile
      id={id}
      onPress={onPress}
      labels={labels}
      isActive={isActive}
      labelsGap="$1"
    />
  );
};
